import { Observable } from 'rxjs/Rx';
import 'rxjs/Rx';
import { AbstractControl, Validator, FormControl } from '@angular/forms';
import { AuthService } from '../core/auth.service';
import { AppInjector } from "../index";
import { AddressBookService } from './address-book.service';
import { IAddressBookSearchData } from './address-book-search-data.model';

interface ICompanyValidator {
    [key: string]: boolean;
}

function checkCompany(control: AbstractControl, existingItem: string): Observable<ICompanyValidator> {

    let abService: AddressBookService = AppInjector.get(AddressBookService);//.get(AuthService).get(Http);
    let reason = 'companyTaken';

    // console.log('checking against: ' + existingItem );

    // Return an observable with null if the
    // project name is not taken
    // an objet with the rejetion reason if it does
    return new Observable((obs: any) => {

        if (control.value.trim() == existingItem || existingItem == '' || !existingItem) {
            console.log('nothing to do, control.value ' + control.value.trim() + ' equals ' + existingItem);
            obs.next(null);
            obs.complete();
            return;
        }
        var searchValue = new IAddressBookSearchData();
        searchValue.companyName = control.value;

        abService.searchCompany(searchValue).subscribe
        (
        (data) => {
            if (data) {
                obs.next({ [reason]: true });
            } else {
                obs.next(null);
            }
            obs.complete();
            
        },
        (error: any) => {
            if (error.status == 404) {
                obs.next(null);
                obs.complete();
            }
            console.log('error...?' + error);
            obs.next({ [reason]: true });
            obs.complete();
            }
        );
    });
}

export class CompanyValidator {

    constructor() { }

    static checkCompanyName(itemId: string = '') {
        return (c: AbstractControl) => {
            return checkCompany(c, itemId);
        }
    }


}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/company-validator.ts